// extracted by mini-css-extract-plugin
export default {"container":"Rarity_container__uqtAm","rarities":"Rarity_rarities__Fjowg","rarityName":"Rarity_rarityName__Yb3gv"};